import { useState } from 'react';
import { Button } from '@/components/ui/button.jsx';
import StandardSetSheet from './StandardSetSheet.jsx';

// "Send the standard set for <policy>" (paperwork-1 D10, screen 3). L1a's stub, filled by L3-2: the button opens the sheet
// (StandardSetSheet: the preview from GET /api/tracon/deals/:dealId/standard-set, one Send, what went to whom read back).
// L2 places it on the Paperwork tab; its label and props are L1a's, unchanged.
//
// @param {object}  props
// @param {string}  props.dealId       the deal (CRM deal id) whose policy's standard set is sent
// @param {string}  props.policyId     the policy (policies.id) the set is for
// @param {string}  props.policyLabel  the policy as a person reads it (tails, term, carrier), never an id
// @param {string}  [props.className]
// @param {Function} [props.onSent]    called with the send's answer (the server's, read back)
export default function SendStandardSetButton({ dealId, policyId, policyLabel, className, onSent }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button type="button" variant="outline" size="sm" className={className} data-deal-id={dealId} data-policy-id={policyId} disabled={!dealId} onClick={() => setOpen(true)}>
        {`Send the standard set for ${policyLabel}`}
      </Button>
      {open ? <StandardSetSheet dealId={dealId} policyLabel={policyLabel} open={open} onOpenChange={setOpen} onSent={onSent} /> : null}
    </>
  );
}
